import { render, staticRenderFns } from "./verDriver.vue?vue&type=template&id=5887c869&scoped=true&"
import script from "./verDriver.vue?vue&type=script&lang=js&"
export * from "./verDriver.vue?vue&type=script&lang=js&"
import style0 from "./verDriver.vue?vue&type=style&index=0&id=5887c869&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5887c869",
  null
  
)

export default component.exports